module.exports = __webpack_public_path__ + "media/assets/good_at/ansible-1b756cc228ec41c39e3b3c19e90f84dc.png";